import React from 'react';
import { travelStyles } from '../mock';
import { SectionHead } from './Destinations';

export default function TravelStyles() {
  return (
    <section id="holidays" className="py-20 md:py-28 bg-[#f6f8fb]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHead
          eyebrow="TRAVEL YOUR WAY"
          title="Travel Designed Around You."
          sub="No two travellers are alike. Discover journeys crafted around your interests, celebrations and travel style."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {travelStyles.map((s, i) => (
            <div
              key={s.title}
              className="group relative rounded-2xl overflow-hidden h-72 reveal shadow-[0_14px_34px_rgba(11,37,69,0.1)]"
              style={{ transitionDelay: `${(i % 3) * 80}ms` }}
            >
              <img src={s.img} alt={s.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071a33]/92 via-[#0B2545]/45 to-[#0B2545]/10" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <h3 className="font-heading text-white text-xl font-bold mb-1">{s.title}</h3>
                <p className="text-white/0 group-hover:text-white/85 text-sm leading-relaxed max-h-0 group-hover:max-h-40 overflow-hidden transition-all duration-500">
                  {s.desc}
                </p>
                <span className="mt-3 inline-block h-1 w-10 rounded-full bg-[#EA5019] transition-all duration-500 group-hover:w-16" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
